import { render, staticRenderFns } from "./DamageAssessorCaseEditAccident.vue?vue&type=template&id=8655659e&scoped=true"
import script from "./DamageAssessorCaseEditAccident.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseEditAccident.vue?vue&type=script&lang=js"
import style0 from "./DamageAssessorCaseEditAccident.vue?vue&type=style&index=0&id=8655659e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8655659e",
  null
  
)

export default component.exports